import React, { useMemo, useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { canAccessPage } from '../../config/navigation';
import ApiConfigurations from './ApiConfigurations';
import EmailConfiguration from '../EmailConfiguration';
import IpBlockTab from './IpBlockTab';

// Administrador: mesmo critério usado pelo backend (role admin ou permissão manage_system).
const isAdmin = (user) =>
  user?.role === 'admin' || user?.profile === 'admin' || (user?.permissions || []).includes('manage_system');

export default function Settings({ api, user }) {
  // Cada aba respeita o acesso à tela que ela substituiu; "Bloqueio por IP" é só para administrador.
  const tabs = useMemo(() => [
    { id: 'api-configurations', label: 'Config. de APIs', visible: canAccessPage('api-configurations', user), render: () => <ApiConfigurations api={api} /> },
    { id: 'email-config', label: 'E-mail', visible: canAccessPage('email-config', user), render: () => <EmailConfiguration /> },
    { id: 'ip-block', label: 'Bloqueio por IP', visible: isAdmin(user), render: () => <IpBlockTab api={api} /> },
  ].filter((t) => t.visible), [api, user]);

  const [active, setActive] = useState(null);
  const current = tabs.find((t) => t.id === active) ? active : tabs[0]?.id;

  if (!tabs.length) return null;

  return (
    <div className="space-y-4 p-4 md:p-6">
      <h1 className="text-2xl font-bold text-slate-900">Configurações</h1>
      <Tabs value={current} onValueChange={setActive}>
        <TabsList>
          {tabs.map((t) => <TabsTrigger key={t.id} value={t.id}>{t.label}</TabsTrigger>)}
        </TabsList>
        {tabs.map((t) => (
          <TabsContent key={t.id} value={t.id}>{current === t.id && t.render()}</TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
